import React, { useContext } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Typography } from '@material-ui/core';
import MyTextField from '../../common/MyTextField';
import pickBkgClass from '../../utils/pickBkgClass';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';

const createPostSchema = Yup.object().shape({
	post_title: Yup.string().min(5).required(),
	post_body: Yup.string().min(5).required()
});

const PostForm = ({
	formInitialValues,
	handleFormSubmit,
	formTitle,
	submitBtnText
}) => {
	const { themeName } = useContext(MyThemeContext);

	// const sleep = ms => new Promise(r => setTimeout(r, ms));

	return (
		<Formik
			initialValues={{ ...formInitialValues }}
			onSubmit={handleFormSubmit}
			validationSchema={createPostSchema}
			enableReinitialize={true}
		>
			{({ values, isSubmitting, handleSubmit, errors, touched }) => (
				<form
					onSubmit={handleSubmit}
					className={`createPostForm ${pickBkgClass(themeName, 'soft')}`}
					autoComplete="off"
				>
					<Typography variant="h2" component="h1" gutterBottom color="primary">
						{formTitle}
					</Typography>
					<MyTextField
						type="text"
						name="post_title"
						label="Enter Post Title..."
						variant="outlined"
						color="primary"
					/>
					<MyTextField
						type="text"
						name="post_body"
						label="Enter Post description..."
						variant="outlined"
						color="primary"
						multiline
						rows={8}
					/>

					<ButtonWithLoading
						isSubmitting={isSubmitting}
						errors={errors}
						btnText={submitBtnText}
						loadingMsg="Please Wait.."
					/>
				</form>
			)}
		</Formik>
	);
};

export default PostForm;
